<template>
  <v-btn v-if="$slots.default" v-bind="$attrs" :variant="variant">
    <slot />
  </v-btn>
  <v-btn v-else v-bind="$attrs" :variant="variant" />
</template>

<script setup>
defineProps({
  variant: {
    type: String,
    default: "elevated"
  }
});
</script>
